<template>
  <q-form
    ref="formRef"
    v-bind="$attrs"
    @input="isDirty = true"
    @validation-error="onValidationError"
  >
    <slot />
  </q-form>
</template>

<script setup>
import { computed, onMounted, ref, toRaw } from 'vue'

const formRef = ref(null)
const formComponents = ref([])
const hasErrors = computed(() => formComponents.value?.some(v => v.hasError))
const isDirty = ref(false)
const validate = param => formRef.value?.validate(param)
const resetValidation = () => formRef.value?.resetValidation()

defineExpose({
  hasErrors,
  isDirty,
  formRef,
  validate,
  resetValidation,
})

onMounted(() => {
  formComponents.value = formRef?.value.getValidationComponents().map(proxy => toRaw(proxy))
})

function onValidationError(component) {
  component.$el?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
    inline: 'nearest',
  })
}
</script>
